import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { fn, hash } from '@ember/helper';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import {
  HdsTabs,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { Typography, FlexGrid, DisclosureGuide } from 'core/components';
import { boxPadding } from 'core/modifiers';
import { AZURE_DISCLOSURE_GUIDES_PEERING } from 'networks-common/utils/azure-connections';
import Bash from 'hcp/components/page/hvn-peerings/detail/content-tabs/azure/code-snippets/bash';

export default class AzureContentTabsCloudShell extends Component {
  @service router;

  azureDisclosureGuides = AZURE_DISCLOSURE_GUIDES_PEERING;

  updateQueryParams = (queryParams = {}) => {
    return this.router.transitionTo(this.router.currentRouteName, {
      queryParams,
    });
  };

  <template>
    <div {{boxPadding "md 0 0 0"}}>
      <div data-test-peering-content-tabs-azure-cloud-shell>
        <div {{boxPadding "0 0 md 0"}}>
          <Typography @variant="body1">
            <div {{boxPadding "0 0 md 0"}}>
              <FlexGrid as |G|>
                <G.Item @xs="12" @sm="12" @md="12" @lg="8">
                  <DisclosureGuide
                    data-test-peering-content-tabs-azure-cloud-shell-disclosure-guide
                    @content={{this.azureDisclosureGuides.cloudShell}}
                  />
                </G.Item>
              </FlexGrid>
            </div>
          </Typography>
          <HdsLinkStandalone
            @iconPosition="trailing"
            @icon="external-link"
            @text={{t
              "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.cloud-shell.link.text"
            }}
            @href={{t
              "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.cloud-shell.link.href"
            }}
          />
        </div>
      </div>
    </div>

    <HdsTabs as |T|>
      <T.Tab
        @isSelected={{eq @product @products.bash.id}}
        data-test-peering-content-tabs-azure-code-snippets-bash
        {{on
          "click"
          (fn this.updateQueryParams (hash product=@products.bash.id))
        }}
      >
        {{t @products.bash.label}}
      </T.Tab>
      <T.Panel />
    </HdsTabs>

    {{! Bash Code Snippets }}
    {{#if (eq @product @products.bash.id)}}
      <Bash @model={{@model}} />
    {{/if}}
  </template>
}
